import { getIdentityList, getNativeMaterialList } from './../../../service/media';
import { IdentityType } from './../../../enums/identity';
import { OriginMaterial } from './../../../pages/media/material';
import identityStore from './index';
const updateNativeVideos = (identityId, cursor, hasMore) => {
  identityStore.mutations.setNativeVideoIdentityId(identityId);
  identityStore.mutations.setNativeVideoCursor(cursor);
  identityStore.mutations.setNativeVideoHasMore(hasMore);
};
const actions = {
  async getIdentityList(): Promise<void> {
    const { identity_list } = await getIdentityList(IdentityType.ALL).catch(() => ({ identity_list: [] }));
    identityStore.mutations.setIdentityList(identity_list);
    return identity_list;
  },
  async getNativeMaterialList(identityType: IdentityType, identityId: string) {
    const { getters } = identityStore;
    const { nativeVideoCursor, nativeVideoHasMore, nativeVideoIdentityId } = getters.identityFormData.value;
    if (nativeVideoIdentityId === identityId && nativeVideoHasMore) {
      const { tt_native_video_list: nativeList, pagination } = await getNativeMaterialList(
        identityType,
        identityId,
        nativeVideoCursor,
      );
      const nativeInfoList = nativeList.map(item => ({
        ...item,
        origin: new OriginMaterial(item?.video_info),
      }));
      const { has_more, cursor } = pagination;
      updateNativeVideos(identityId, cursor, has_more);
      identityStore.mutations.updateNativeVideoList(nativeInfoList);
      return;
    }
    const { tt_native_video_list: nativeList, pagination } = await getNativeMaterialList(
      identityType,
      identityId,
      0,
    ).catch(() => ({ tt_native_video_list: [], pagination: { cursor: 0, has_more: false } }));
    const nativeInfoList = nativeList.map(item => ({
      ...item,
      origin: new OriginMaterial(item?.video_info),
    }));
    const { has_more, cursor } = pagination;
    updateNativeVideos(identityId, cursor, has_more);
    identityStore.mutations.setNativeVideoList(nativeInfoList);
    return;
  },
};
export default actions;
